import 'core-js/modules/es.string.trim.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.promise.js';
import { __awaiter } from '../_virtual/_tslib.js';
import { AnalyticsProvider } from '@hub-la/fe-core-analytics';
import Cookies from 'js-cookie';
import isNil from 'lodash/isNil';
import platformDetect from 'platform-detect';
import tldjs from 'tldjs';
import { v4 } from 'uuid';

class RudderStackAnalytics extends AnalyticsProvider {
  constructor(writeKey, dataPlaneUrl, isDebug) {
    super();
    this.writeKey = writeKey;
    this.dataPlaneUrl = dataPlaneUrl;
    this.isDebug = isDebug;
    this.getOS = os => {
      let result = 'unknown';
      if (os === null || os === void 0 ? void 0 : os.windows) result = 'windows';else if (os === null || os === void 0 ? void 0 : os.android) result = 'android';else if (os === null || os === void 0 ? void 0 : os.chromeos) result = 'chromeos';else if (os === null || os === void 0 ? void 0 : os.macos) result = 'macos';else if (os === null || os === void 0 ? void 0 : os.ios) result = 'ios';else if (os === null || os === void 0 ? void 0 : os.tizen) result = 'tizen';else if ((os === null || os === void 0 ? void 0 : os.linux) || (os === null || os === void 0 ? void 0 : os.linuxBased)) result = 'linux';
      return result;
    };
    this.removeNullProperties = obj => {
      const ret = {};
      Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (Array.isArray(value) && (value.length === 0 || value.every(item => item === '' || isNil(item)))) {
          delete obj[key];
          return;
        }
        if (typeof value === 'string' && value.trim() === '') {
          delete obj[key];
          return;
        }
        if (!Array.isArray(value) && value instanceof Object) {
          delete obj[key];
          return;
        }
        if (isNil(value)) {
          delete obj[key];
          return;
        }
        if (Array.isArray(value)) {
          ret[key] = value.filter(item => item !== '' && !isNil(item));
          return;
        }
        ret[key] = value;
      });
      return ret;
    };
    !this.isDebug && this.rudderstack().then(rudderstack => rudderstack.load(this.writeKey, this.dataPlaneUrl));
  }
  identify(user) {
    !this.isDebug && this.rudderstack().then(rudderstack => {
      rudderstack.identify({
        userId: user === null || user === void 0 ? void 0 : user.id,
        traits: this.removeNullProperties({
          firstName: user === null || user === void 0 ? void 0 : user.firstName,
          lastName: user === null || user === void 0 ? void 0 : user.lastName,
          email: user === null || user === void 0 ? void 0 : user.email,
          phoneNumber: user === null || user === void 0 ? void 0 : user.phoneNumber
        })
      });
    });
  }
  track(event, properties) {
    return __awaiter(this, void 0, void 0, function* () {
      const rudderstack = yield this.rudderstack();
      this.isDebug ? console.log(event, this.getDefaultProperties(properties)) : rudderstack.track(event, this.getDefaultProperties(properties));
    });
  }
  page(page, properties) {
    return __awaiter(this, void 0, void 0, function* () {
      const rudderstack = yield this.rudderstack();
      this.isDebug ? console.log(page, this.getDefaultProperties(properties)) : rudderstack.page(page, page, this.getDefaultProperties(properties));
    });
  }
  getDefaultProperties(properties) {
    const deviceType = platformDetect.formfactor;
    const deviceOS = this.getOS(platformDetect);
    const hbId = RudderStackAnalytics.getAnalyticsId();
    return this.removeNullProperties(Object.assign(Object.assign({}, properties), {
      deviceType,
      deviceOS,
      hbId
    }));
  }
  static getAnalyticsId() {
    try {
      const hbIdKey = 'hb_id';
      let hbId = Cookies.get(hbIdKey);
      if (!hbId) {
        hbId = v4();
        const domain = window.location.hostname === 'localhost' ? 'localhost' : tldjs.getDomain(window.location.href);
        Cookies.set(hbIdKey, hbId, {
          sameSite: 'lax',
          expires: 20 * 365,
          domain: `.${domain}`
        });
      }
      return hbId;
    } catch (e) {
      return undefined;
    }
  }
  rudderstack() {
    return __awaiter(this, void 0, void 0, function* () {
      if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
        return {
          track: () => {},
          load: () => {},
          page: () => {},
          identify: () => {}
        };
      }
      const rudderstack = yield import('rudder-sdk-js');
      return rudderstack;
    });
  }
}

export { RudderStackAnalytics };
